module.exports = __webpack_public_path__ + "img/awb-system-error.9c883a47.svg";